import React from "react"
import styled from "styled-components"
import Swiper from "react-id-swiper"
import Img from "@kframesa/react-crosscast-lazy-image"

import { Pic } from "../../styled/pic-info"

const SwiperContainer = styled.div`
  position: relative;

  .swiper-wrapper {
    align-items: center;
  }

  .icon-left,
  .icon-right {
    color: #fff;
    cursor: pointer;
    font-size: 20px;
    position: absolute;
    text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;

    @media only screen and (min-width: ${props => props.theme.mq.small}) {
      font-size: 30px;
    }

    &:focus {
      outline: none;
    }
  }

  .icon-left {
    left: 5px;

    @media only screen and (min-width: ${props => props.theme.mq.small}) {
      left: 15px;
    }
  }

  .icon-right {
    right: 5px;

    @media only screen and (min-width: ${props => props.theme.mq.small}) {
      right: 15px;
    }
  }

  .swiper-button-disabled {
    display: none;
  }
`

const Slider = ({ config }) => {
  const slides = JSON.parse(config)

  const swiperParams = {
    slidesPerView: 1,
    touchReleaseOnEdges: true,
    spaceBetween: 30,
    navigation: {
      nextEl: `.icon-right`,
      prevEl: `.icon-left`,
    },
  }

  return (
    <div>
      <SwiperContainer>
        <Swiper {...swiperParams}>
          {slides.length > 0 &&
            slides.map(slide => (
              <div key={slide.guid}>
                <Pic.Credits>{slide.credits}</Pic.Credits>
                <Img
                  alt={slide.alt}
                  title={slide.title}
                  platformSlug={slide.slug}
                  imageGuid={slide.guid}
                  fluid={{
                    maxWidth: 690,
                    size: 385,
                    step: 305,
                    sizes: [`(max-width: 425px) 385px`, `690px`],
                  }}
                  width={slide.width}
                  height={slide.height}
                  ext={slide.ext}
                />
                <Pic.Caption>{slide.caption}</Pic.Caption>
              </div>
            ))}
        </Swiper>
      </SwiperContainer>
    </div>
  )
}

export default Slider
